"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextNumberInput = void 0;
const React = require("react");
const BaseInput_1 = require("../BaseInput");
const KeypadWrapper_1 = require("../../atoms/KeypadWrapper");
const Keypad_1 = require("../../atoms/Keypad");
class TextNumberInput extends BaseInput_1.BaseInput {
    constructor(props) {
        super(props);
        this.bannedValuesRegex = /[^\d\s]/g;
    }
    render() {
        const { value = "", placeholder = "", disabled = false, hideKeypad = false, maxLength } = this.props;
        const input = (React.createElement("input", { "data-test": "input", type: "text", onChange: evt => {
                this.onInputChange(evt.target.value);
            }, value: value, placeholder: placeholder, disabled: disabled, maxLength: maxLength }));
        return hideKeypad ? (input) : (React.createElement(KeypadWrapper_1.KeypadWrapper, { inputComponent: input, keypadComponent: React.createElement(Keypad_1.NumberKeypad, null) }));
    }
}
exports.TextNumberInput = TextNumberInput;
//# sourceMappingURL=index.js.map